import { render, staticRenderFns } from "./topbarAddPosition.vue?vue&type=template&id=a49115fa&"
import script from "./topbarAddPosition.vue?vue&type=script&lang=js&"
export * from "./topbarAddPosition.vue?vue&type=script&lang=js&"
import style0 from "./topbarAddPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports